/* eslint-disable no-inner-declarations */
/* eslint-disable @typescript-eslint/no-namespace */
import { BasicDealVersion, SyndicateMember } from '../../types/deal.types';
import { addOrUpdateItem } from '../arrays';
import { OptionsType } from '../issue/maturity';
import { MapperHelpers } from '../mappers';

export namespace DealsSyndicates {
  export function getSyndicateDepartmentNames(deals: BasicDealVersion[]) {
    return MapperHelpers.getUniqSortedItemPropertiesFromArray(deals, {
      getProperty: (deal: BasicDealVersion) => deal.syndicate,
      getArrayProperty: (syndicates: SyndicateMember[]) =>
        syndicates.map(
          (syndicate: SyndicateMember) =>
            syndicate.shortName || syndicate.departmentName
        ),
      sortBy: (name: string) => name,
      uniqBy: (name: string) => name
    });
  }

  export function getUniqueSyndicates(deals: BasicDealVersion[]) {
    return MapperHelpers.getUniqSortedItemPropertiesFromArray(deals, {
      getProperty: (deal: BasicDealVersion) => deal.syndicate,
      getArrayProperty: (syndicates: SyndicateMember[]) => syndicates,
      sortBy: (member: SyndicateMember) =>
        member ? member.departmentName : '',
      uniqBy: (member: SyndicateMember) =>
        '' + (member ? member.departmentName : '')
    });
  }

  export function getUniqueReducedSyndicates(deals: BasicDealVersion[]) {
    return deals.reduce<SyndicateMember[]>((acc, deal) => {
      return deal.syndicate.reduce<SyndicateMember[]>(
        (allMembers, potentiallyNewMember) => {
          const findPredicate = function (member: SyndicateMember) {
            if (member.departmentName === OptionsType.Blank) {
              return member.departmentName === OptionsType.Blank;
            }

            if (member.orionId && potentiallyNewMember.orionId) {
              return member.orionId === potentiallyNewMember.orionId;
            }

            if (member.shortName && potentiallyNewMember.shortName) {
              return member.shortName === potentiallyNewMember.shortName;
            }

            return (
              member.departmentName === potentiallyNewMember.departmentName
            );
          };
          return addOrUpdateItem(
            allMembers,
            potentiallyNewMember,
            findPredicate,
            updateMemberRecord
          );
        },
        acc
      );
    }, []);
  }

  export function getSyndicateName(member: SyndicateMember): string {
    return member.shortName || member.departmentName;
  }

  function updateMemberRecord(
    oldRecord: SyndicateMember,
    newRecord: SyndicateMember
  ): SyndicateMember {
    const updatedRecord = { ...oldRecord };
    if (!updatedRecord.shortName && newRecord.shortName) {
      updatedRecord.shortName = newRecord.shortName;
    }

    return updatedRecord;
  }
}
